'use client';

import React, { useEffect, useState } from 'react';
import { TestNetHeader } from 'components/Testnet/TestNetHeader';
import { appConfig } from 'utils/app.config';
import { HeaderCommon } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderCommon';
import { Footer } from 'structure/Layouts/SFILayouts/BaseLayout/components/Footer';
import { Banner } from 'structure/Layouts/SFILayouts/BaseLayout/components/Banner';

export default function Testnet() {
  const [isBannerClosed, setIsBannerClosed] = useState(false);

  useEffect(() => {
    setIsBannerClosed(Boolean(sessionStorage?.getItem('isBannerVisible')));
  }, []);

  const handleCloseBanner = () => {
    setIsBannerClosed(true);
  };

  return (
    <>
      <Banner onClose={handleCloseBanner} />
      <div
        className={`flex h-screen ${appConfig.featureFlags.ENABLE_BANNER && !isBannerClosed && 'lg:h-[calc(100vh-2rem)]'} w-full flex-col items-center overflow-y-auto bg-box-primary`}
      >
        <HeaderCommon isBannerClosed={isBannerClosed} />
        <TestNetHeader />
        <div className='flex w-full max-w-[100rem] flex-col items-center px-5 pt-4 lg:px-7 lg:pt-24'>
          <Footer />
        </div>
      </div>
    </>
  );
}
